import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ProductSale } from "../../../interfaces/tickets/ProductSale";
import { phoneMask } from "../../../utils/masks";
import { environment } from "../../../../environments/environment";
import { RequestsServices } from "src/app/services/requests.service";

declare const grecaptcha: any;

@Component({
  selector: "ng-tickets-send-data",
  styleUrls: ["./send-data.component.scss", "../../tickets/styles/ticket.scss"],
  template: `
    <section>
      <ng-tickets-payment-resume
        [productSale]="productSale"
      ></ng-tickets-payment-resume>

      <h2 class="title-section">Insira os dados de envio dos cupons</h2>

      <form #form="ngForm">
        <div class="row container-form-card">
          <div class="col-md-12">
            <div class="form-group">
              <label>Email*</label>
              <input
                class="form-control"
                type="text"
                name="email"
                [(ngModel)]="productSale.user.email"
                required
              />
              <span class="error-description"></span>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label>Telefone*</label>
              <input
                class="form-control"
                type="text"
                name="phone"
                minlength="14"
                [textMask]="{ mask: phoneMask, guide: false }"
                [(ngModel)]="productSale.user.phone"
                required
              />
              <span class="error-description"></span>
            </div>
          </div>
        </div>

        <h2 class="title-section">Política de reembolso</h2>
        <div class="container-refund-policy">
          <div class="checkbox-refund-policy">
            <input
              [(ngModel)]="agreeRefundPolicy"
              name="refund-policy"
              id="refund-policy"
              type="checkbox"
              required
            />
          </div>

          <label for="refund-policy">
            <p class="description-refund-policy">
              Estou de acordo com a
              <a
                href="https://ajuda.allya.com.br/pt-BR/collections/374989-para-voce"
                target="_blank"
                *ngIf="redirectInfo[groupType].name == 'Cinemark'"
                >política de Reembolso de Ingresso
                <i class="fa fa-external-link"></i>
              </a>
              <a
                href="https://ajuda.allya.com.br/pt-BR/articles/9123688-estorno-99"
                target="_blank"
                *ngIf="redirectInfo[groupType].name == '99'"
                >política de reembolso de voucher
                <i class="fa fa-external-link"></i>
              </a>
            </p>
          </label>
        </div>
      </form>
      <div #captchaRef></div>
      <div class="container-button">
        <button class="btn btn-pink" (click)="nextStep.emit('card-selection')">
          <i class="fa fa-chevron-left"></i> Voltar
        </button>
        <button
          class="btn btn-pink"
          (click)="nextStep.emit('checkout')"
          [disabled]="form.invalid || !captchaSuccess"
        >
          Finalizar compra<i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </section>
  `,
})
export class SendDataComponent implements AfterViewInit {
  @ViewChild("captchaRef") captchaRef: ElementRef;
  ssoToken: string;
  title = "cinema";
  SITE_KEY = environment.RECAPTCHA_KEY;
  reCaptchaId: number;
  captchaSuccess = false;

  @Input() groupType: string;
  @Input() productSale: ProductSale;
  @Output() nextStep = new EventEmitter();

  constructor(private request: RequestsServices) {}

  ngAfterViewInit() {
    this.renderCaptcha();
  }

  renderCaptcha() {
    this.reCaptchaId = grecaptcha.render(this.captchaRef.nativeElement, {
      sitekey: this.SITE_KEY,
      callback: () => this.onCaptchaSuccess(),
      "error-callback": () => this.onCaptchaError(),
      "expired-callback": () => this.onCaptchaExpired(),
    });
  }

  onCaptchaSuccess() {
    this.sendCaptchaToken();
  }

  onCaptchaError() {
    this.captchaSuccess = false;
  }

  onCaptchaExpired() {
    this.captchaSuccess = false;
  }

  sendCaptchaToken() {
    const captchaResponse = grecaptcha.getResponse(this.reCaptchaId);

    const data = {
      captchaToken: captchaResponse,
      applicationName: "portal",
    };

    this.request.post("recaptcha", data).then(
      () => {
        this.captchaSuccess = true;
      },
      () => {
        this.captchaSuccess = false;
      }
    );
  }

  redirectInfo = {
    primepass: { name: "Primepass", url: "primepass.club" },
    cinemark: { name: "Cinemark", url: "cinemark.com.br" },
    99: { name: "99", url: "" },
  };

  phoneMask = phoneMask;
  agreeRefundPolicy = false;
  refundPolicyLink =
    "https://www.allya.com.br/d/documentos/politica-de-cancelamento-cinemark.pdf";
}
